import {
    bpmsResourcesManagerApi,
    notificationTemplatesSettingsApi,
} from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class SettingsNotificationTemplatesStoreClass extends BasicStore<any> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-75-notification-templates.json';

    itemEditFormKey =
        'embedded:deployment:forms/bo/bo-76-edit-notification-template.json';

    api: BasicStoreApi<any> = {
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(formKey, options),
            );
        },
        loadItem: (id: number, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                notificationTemplatesSettingsApi.getNotificationTemplate(
                    id,
                    options,
                ),
            );
        },
        updateItem: (id, data, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                notificationTemplatesSettingsApi.updateNotificationTemplate(
                    Number(id),
                    data,
                    options,
                ),
            );
        },
    };
}

export const SettingsNotificationTemplatesStore =
    new SettingsNotificationTemplatesStoreClass();
